import { render, staticRenderFns } from "./RoomModal.vue?vue&type=template&id=06301a40&scoped=true"
import script from "./RoomModal.vue?vue&type=script&lang=js"
export * from "./RoomModal.vue?vue&type=script&lang=js"
import style0 from "./RoomModal.vue?vue&type=style&index=0&id=06301a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06301a40",
  null
  
)

export default component.exports